import * as React from "react";
import ConfirmModal from "./confirmModal";
import ContractlistState, {ArchivedState, ListContract} from "../ContractlistState";
import {connect} from "react-redux";
import {
    archiveContract,
    ArchiveContract, deleteContract, DeleteContract
} from "../actions";
import * as selectors from "../selectors";

interface TagProps {
    contract: ListContract,
}

interface DispatchProps {
    doArchiveContract: ArchiveContract,
    doDeleteContract: DeleteContract,
}

interface StateProps {
    hasCreatePermission: boolean
}

interface RowActionsState {
}

type Props = TagProps & StateProps & DispatchProps;

const mapStateToProps = (state: ContractlistState): StateProps => {
    return {
        hasCreatePermission: selectors.hasCreatePermission(state),
    };
};

const mapDispatchToProps: DispatchProps = ({
    doArchiveContract: archiveContract,
    doDeleteContract: deleteContract,
});

class ContractRowActionsComponent extends React.Component<Props, RowActionsState> {

    render(){
        const {contract, hasCreatePermission} = this.props;
        return (
            <div className={"contract-results__row-actions-container"}>

                <a href={`#!/newcontract/${contract.id}`} title={"Kopier kontrakt"} className={"link-nostyle"}>
                    <span className={"contract-results__row-action glyphicon glyphicon-duplicate" + (hasCreatePermission? "" : " contract-results__row-action--disabled")} />
                    <span className={"sr-only"}>Kopier kontrakt</span>
                </a>
                <ConfirmModal
                    isEnabled={contract.canArchive}
                    contractId={contract.id}
                    modalMessage={"Er du sikker på at du vil " + (contract.archivedState === 'ARCHIVED' ? "reaktivere" : "arkivere") + " denne kontrakten?"}
                    modalTitle={contract.archivedState === 'ARCHIVED' ? "Reaktiver kontrakt" : "Arkiver kontrakt"}
                    classString={
                        "contract-results__row-action "
                        + (contract.archivedState == 'ARCHIVED' ? 'glyphicon glyphicon-folder-close' : 'glyphicon glyphicon-folder-open')
                        + (contract.canArchive ? "" : " contract-results__row-action--disabled")
                    }
                    onConfirm={() => this.handleArchiveContract(contract.id, contract.archivedState)}
                />
                <ConfirmModal
                    isEnabled={contract.canDelete}
                    contractId={contract.id}
                    modalMessage={"Er du sikker på at du vil slette denne kontrakten?"}
                    modalTitle={"Slett kontrakt"}
                    classString={"contract-results__row-action glyphicon glyphicon-trash" + (contract.canDelete ? "" : " contract-results__row-action--disabled")}
                    onConfirm={() => this.handleDeleteContract(contract.id)}
                />
        </div>
        );
    }

    handleArchiveContract = function (contractId: string, archivedState: ArchivedState) {
        this.props.doArchiveContract(contractId, archivedState === "OPEN" ? "ARCHIVED" : "OPEN");
    };

    handleCopyContract = function (contractId: string) {
        window.location.hash = "#!/newcontract/"+contractId;
    };

    handleDeleteContract = function (contractId: string) {
        this.props.doDeleteContract(contractId);
    };
}

export const ContractRowActions = connect(mapStateToProps, mapDispatchToProps)(ContractRowActionsComponent);